// import React, { useState } from "react";

// const modalStyles = {
//   overlay: {
//     position: "fixed",
//     inset: "0px",
//     backgroundColor: "rgba(0, 0, 0, 0.5)",
//     zIndex: 999999,
//     overflowY: "auto",
//   },
//   modal: {
//     background: "rgb(255, 255, 255)",
//     borderRadius: "10px",
//     maxWidth: "800px",
//     margin: "91px auto",
//     padding: "13px",
//     // height: "80vh",
//     overflowY: "hidden",
//     position: "relative",
//   },
//   closeButton: {
//     position: "absolute",
//     right: "10px",
//     top: "10px",
//     cursor: "pointer",
//     border: "none",
//     background: "transparent",
//     fontSize: "20px",
//   },
//   header: {
//     fontSize: "24px",
//     fontWeight: "bold",
//     marginBottom: "10px",
//   },
//   scrollableContent: {
//     maxHeight: "300px",
//     overflowY: "auto",
//     paddingRight: "10px",
//     marginBottom: "20px",
//   },
//   checkboxContainer: {
//     fontSize: "10px",
//     fontWeight: "600",
//   },
//   actionButtons: {
//     display: "flex",
//     justifyContent: "flex-end",
//     gap: "10px",
//     marginTop: "-37px",
//   },
//   cancelButton: {
//     width: "100px",
//     padding: "10px",
//   },
//   okButton: {
//     padding: "0px",
//     width: "40px",
//   },
// };

// const PopupModal = ({ onClose, onAgree }) => {
//   const [isTermsChecked, setIsTermsChecked] = useState(false);
//   const [isPrivacyChecked, setIsPrivacyChecked] = useState(false);

//   const handleTermsChange = (event) => {
//     setIsTermsChecked(event.target.checked);
//   };

//   const handlePrivacyChange = (event) => {
//     setIsPrivacyChecked(event.target.checked);
//   };

//   const isOkButtonEnabled = isTermsChecked && isPrivacyChecked;

//   return (
//     <div style={modalStyles.overlay}>
//       <div style={modalStyles.modal}>
//         <button style={modalStyles.closeButton} onClick={onClose}>
//           ×
//         </button>
//         <div>
//           <p>
//             <strong>Terms and Conditions</strong>
//           </p>

//           <div style={modalStyles.scrollableContent}>
//             <p style={{ fontSize: "10px" }}>
//               <div>
//                 <p style={{ display: "table-cell" }}><strong>Render Policy</strong></p>
//                 Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,
//                 consectetur, adipisci velit, sed quia non numquam eius modi tempora
//                 incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut
//                 enim ad minima veniam, quis nostrum exercitationem ullam corporis
//                 suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur?
//                 Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse
//                 quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat
//                 quo voluptas nulla pariatur?
//               </div>

//               <div style={{ marginTop: "10px" }}>
//                 <p style={{ display: "table-cell" }}><strong>General Policy</strong></p>
//                 1914 translation by H. Rackham "But I must explain to you how all this mistaken idea of denouncing
//                 pleasure and praising pain was born and I will give you a complete
//                 account of the system, and expound the actual teachings of the great
//                 explorer of the truth, the master-builder of human happiness. No
//                 one rejects, dislikes, or avoids pleasure itself, because it is
//                 pleasure, but because those who do not know how to pursue pleasure
//                 rationally encounter consequences that are extremely painful. Nor
//                 again is there anyone who loves or pursues or desires to obtain pain
//                 of itself, because it is pain,
//               </div>

//               <div style={{ marginTop: "10px" }}>
//                 <p style={{ display: "table-cell" }}><strong>Third Party Policy</strong></p>
//                 but because occasionally circumstances
//                 occur in which toil and pain can procure him some great pleasure. To
//                 take a trivial example, which of us ever undertakes laborious
//                 physical exercise, except to obtain some advantage from it? But who
//                 has any right to find fault with a man who chooses to enjoy a
//                 pleasure that has no annoying consequences, or one who avoids a pain
//                 that produces no resultant pleasure?"
//                 Section 1.10.33 of "de Finibus Bonorum et Malorum", written by
//                 Cicero in 45 BC
//                 "At vero eos et accusamus et iusto odio dignissimos ducimus qui
//                 blanditiis praesentium voluptatum deleniti atque corrupti quos
//                 dolores et quas molestias excepturi sint occaecati cupiditate non
//                 provident, similique sunt in culpa qui officia deserunt mollitia
//                 animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis
//                 Temporibus autem quibusdam et aut officiis debitis aut
//                 rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint
//                 et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente
//                 delectus, ut aut reiciendis voluptatibus maiores alias consequatur
//                 aut perferendis doloribus asperiores repellat."
//                 1914 translation by H. Rackham
//               </div>
//             </p>
//           </div>
//           <div style={modalStyles.checkboxContainer}>
//             <input type="checkbox" checked={isTermsChecked} onChange={handleTermsChange} /> I agree to the Terms and Conditions
//             <br />
//             <input type="checkbox" checked={isPrivacyChecked} onChange={handlePrivacyChange} /> I agree to the Privacy Policy
//           </div>
//           <div style={modalStyles.actionButtons}>
//             <button className="btn btn-secondary" style={modalStyles.cancelButton} onClick={onClose}>
//               Cancel
//             </button>
//             <button
//               className="btn btn-danger"
//               style={modalStyles.okButton}
//               onClick={onAgree}
//               disabled={!isOkButtonEnabled}
//             >
//               OK
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PopupModal;


import React, { useState } from "react";

const modalStyles = {
  overlay: {
    position: "fixed",
    inset: "0px",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 999999,
    overflowY: "auto",
  },
  modal: {
    background: "rgb(255, 255, 255)",
    borderRadius: "10px",
    maxWidth: "50vw",
    margin: "91px auto",
    // padding: "13px",
    overflowY: "hidden",
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    right: "10px",
    top: "0.7vh",
    cursor: "pointer",
    border: "none",
    background: "transparent",
    fontSize: "25px",
    color: "white"
  },
  header: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  scrollableContent: {
    maxHeight: "300px",
    overflowY: "auto",
    minHeight: "50vh",
    paddingRight: "10px",
    marginBottom: "20px",
  },
  checkboxContainer: {
    fontSize: "10px",
    fontWeight: "600",
    padding: "1rem"
  },
  actionButtons: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "-37px",
    marginBottom: "20px"
  },
  cancelButton: {
    width: "100px",
    padding: "10px",
  },
  okButton: {
    padding: "0px",
    width: "40px",
  },
};

const PopupModal = ({ onClose, onAgree, policies }) => {
  const [isTermsChecked, setIsTermsChecked] = useState(false);
  const [isPrivacyChecked, setIsPrivacyChecked] = useState(false);

  const handleTermsChange = (event) => {
    setIsTermsChecked(event.target.checked);
  };

  const handlePrivacyChange = (event) => {
    setIsPrivacyChecked(event.target.checked);
  };

  const isOkButtonEnabled = isTermsChecked && isPrivacyChecked;

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.modal}>
        <button style={modalStyles.closeButton} onClick={onClose}>
          ×
        </button>
        <p className="mb-0 p-3 text-white" style={{backgroundColor:"#ee373b"}}>
          <strong>Terms and Conditions</strong>
        </p>
        <div style={{margin:"13px"}}>
          <div style={modalStyles.scrollableContent}>
            <p style={{ fontSize: "10px" }}>
              {Object.entries(policies).map(([title, content], index) => (
                <div key={index} style={{ marginTop: index !== 0 ? "10px" : "0px" }}>
                  <p style={{ display: "table-cell" }}><strong>{title}</strong></p>
                  {content}
                </div>
              ))}
            </p>
          </div>
          <div style={modalStyles.checkboxContainer}>
            <input type="checkbox" checked={isTermsChecked} onChange={handleTermsChange} style={{width:"unset !important", height: "unset !important"}} /> I agree to the Terms and Conditions
            <br />
            <input type="checkbox" checked={isPrivacyChecked} onChange={handlePrivacyChange} style={{width:"unset !important", height: "unset !important"}} /> I agree to the Privacy Policy
          </div>
          <div style={modalStyles.actionButtons}>
            {/* <button className="btn btn-secondary" style={modalStyles.cancelButton} onClick={onClose}>
              Cancel
            </button> */}
            <span></span>
            <button
              className="btn btn-danger"
              style={modalStyles.okButton}
              onClick={onAgree}
              disabled={!isOkButtonEnabled}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupModal;
